import type { McpTool, TestResult } from './hooks/useMcpServers';

/** Converts a header array into a Record, skipping entries with empty key or value. */
export const buildHeadersRecord = (
  headers: Array<{ key: string; value: string }>
): Record<string, string> => {
  const result: Record<string, string> = {};
  for (const h of headers) {
    if (h.key.trim() && h.value.trim()) {
      result[h.key.trim()] = h.value.trim();
    }
  }
  return result;
};

type ListedTool = NonNullable<TestResult['tools']>[number];

/** The stored shape of a tool the server listed. Keeps the server's annotations. */
export const toMcpTool = (tool: ListedTool): McpTool => ({
  name: tool.name,
  description: tool.description ?? '',
  inputSchema: tool.inputSchema ?? {},
  annotations: tool.annotations,
});
